import moment from "moment";

const CACHE_KEY = "DEKO-X-CACHE";
const EXPIRE_DAYS = 7;

const memoryStore = new Map<string, unknown>();

export const cacheCleanup = async () => {
  const cache = await caches.open(CACHE_KEY);
  const requests = await cache.keys();

  requests.forEach(request => {
    cache.match(request).then(response => {
      if (response) {
        const timestamp = response.headers.get("x-cache-timestamp");
        if (moment().diff(moment(timestamp), "day") > EXPIRE_DAYS) {
          cache.delete(request);
        }
      }
    });
  });
};

export const deleteAllCache = async () => {
  memoryStore.clear();
  await caches.delete(CACHE_KEY);
};

export const deleteCache = async (key: string) => {
  memoryStore.delete(key);
  const cache = await caches.open(CACHE_KEY);
  cache.delete(key);
};

export const saveCache = async (key: string, data: unknown, options?: { memory?: boolean }) => {
  if (options?.memory) {
    memoryStore.set(key, data);
    return;
  }

  try {
    const cache = await caches.open(CACHE_KEY);

    const response = new Response(JSON.stringify(data), {
      status: 200,
      statusText: "OK",
      headers: {
        "Content-Type": "application/json",
        "x-cache-timestamp": moment().toISOString()
      }
    });

    await cache.put(key, response);
  } catch (error) {
    deleteAllCache();
  }
};

export const getCache = async (key: string) => {
  if (memoryStore.has(key)) {
    const data = memoryStore.get(key);
    return new Response(JSON.stringify(data), {
      status: 200,
      statusText: "OK",
      headers: { "Content-Type": "application/json" }
    });
  }

  const cache = await caches.open(CACHE_KEY);
  return cache.match(key);
};

const sortDeep = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(sortDeep).sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
  if (value !== null && typeof value === "object") {
    return Object.keys(value as object)
      .sort()
      .reduce((acc, k) => ({ ...acc, [k]: sortDeep((value as Record<string, unknown>)[k]) }), {});
  }
  return value;
};

export const makeCacheKey = (url: string, params?: Record<string, unknown>, body?: unknown): string => {
  const parts: string[] = [url];
  if (params && Object.keys(params).length > 0) parts.push(JSON.stringify(sortDeep(params)));
  if (body !== null && body !== undefined) parts.push(JSON.stringify(sortDeep(body)));
  return parts.join(":");
};
